/** localStorage helpers for sticky-note "NEW" indicators (per user). */

export const getStickySeenKey = (userId) => `stickyNotesSeen_${userId}`;

export const getStickySeenMap = (userId) => {
  try {
    return JSON.parse(localStorage.getItem(getStickySeenKey(userId)) || '{}');
  } catch {
    return {};
  }
};

export const markStickyNotesSeen = (notes, userId) => {
  if (!userId || !Array.isArray(notes)) return;
  const map = getStickySeenMap(userId);
  const now = Math.floor(Date.now() / 1000);
  notes.forEach((n) => {
    if (!n?.id) return;
    const t = Number(n.updated_on || n.timestamp || now);
    map[n.id] = Math.max(Number(map[n.id] || 0), t);
  });
  localStorage.setItem(getStickySeenKey(userId), JSON.stringify(map));
};

/** Baseline existing notes on first run so rollout does not mark everything NEW. */
export const ensureStickySeenBaseline = (notes, userId) => {
  if (!userId) return;
  const key = getStickySeenKey(userId);
  if (localStorage.getItem(key) !== null) return;
  markStickyNotesSeen(notes, userId);
};

/**
 * NEW when shared with you, or edited by someone else (not your own save).
 */
export const isStickyNoteNew = (note, userId, seenMap) => {
  if (!note?.id || !userId) return false;
  const activityAt = Number(note.updated_on || note.timestamp || 0);
  const lastSeen = Number(seenMap?.[note.id] || 0);
  if (!activityAt || activityAt <= lastSeen) return false;

  const uid = Number(userId);
  const addedBy = Number(note.added_by);
  const updatedBy = Number(note.updated_by || note.added_by);

  // Shared with me (or shared note activity)
  if (addedBy !== uid) return true;
  // My note edited by someone else
  if (addedBy === uid && updatedBy !== uid) return true;
  return false;
};
